import { generateExcel, generateCSV } from '../lib/exportExcel';
import type { Transaction, TransactionSummary } from '../types';

interface ExportButtonProps {
  transactions: Transaction[];
  summaries: TransactionSummary[];
  regionName: string;
  disabled?: boolean;
}

export default function ExportButton({ transactions, summaries, regionName, disabled }: ExportButtonProps) {
  const handleExportExcel = () => {
    generateExcel(transactions, summaries, regionName);
  };

  const handleExportCSV = () => {
    generateCSV(transactions, regionName);
  };

  return (
    <div className="flex gap-2">
      <button
        className="btn btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={handleExportExcel}
        disabled={disabled || transactions.length === 0}
      >
        📊 Excel 다운로드
      </button>
      <button
        className="btn btn-secondary disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={handleExportCSV}
        disabled={disabled || transactions.length === 0}
      >
        📄 CSV 다운로드
      </button>
    </div>
  );
}